"use client";

import { Children } from "react";

import CardNewsByCategory from "./components/card-news-by-category/card-news-by-category";
import useNewsList from "../../use-news-list";

const NewsByCategory = () => {
  const { categories } = useNewsList();
  const categoriesWithNews = categories.filter((item) => item.news.length > 0);
  return (
    <section className="grid grid-cols-1 tabletSmall:grid-cols-2 desktopLarge:grid-cols-3 desktopXlarge::grid-cols-4 gap-size-x10">
      {Children.toArray(
        categoriesWithNews.map((category) => {
          return <CardNewsByCategory key={category.id} data={category} />;
        })
      )}
    </section>
  );
};

export default NewsByCategory;
